import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import Configurations from '../../../settings';
import { toastFn } from 'src/utils/helpers';
import { track } from '../../../utils/telemetry';

let uploadController: AbortController | null = null;

const submitInstantBidFile = async (data: any) => {
  try {
    const formData = new FormData();
    formData.append('file', data.file);

    if (uploadController) {
      uploadController.abort();
    }

    uploadController = new AbortController();
    const response = await axios.post(
      `${Configurations.REACT_APP_API_ADDINSTANTBID}/jobs/upload?member_id=${data.memberId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        signal: uploadController.signal,
        onUploadProgress: progressEvent => {
          if (!progressEvent.total) return;

          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          data.onUploadProgress?.(progress);
        },
      },
    );

    return response.data;
  } catch (error: any) {
    if ( error.code === 'ERR_CANCELED' || error.name === 'CanceledError'
      || error.name === 'AbortError') {
      throw error;
    }
    toastFn(
      'error',
      'Failed to upload instant bid file. Please try again.',
    );

    track(
      'SubmitInstantBidFile -- useSubmitInstantBidFile.ts -- ERROR:',
      { error },
    );

    throw error;
  }
};

export const cancelInstantBidUpload = () => {
  uploadController?.abort();
  uploadController = null;
};

export const useSubmitInstantBidFile = (options = {}) => {
  return useMutation({
    mutationFn: async (data: any) => {
      if (!data?.file) {
        throw new Error('File is required');
      }

      return submitInstantBidFile(data);
    },
    ...options,
  });
};
